// CANDA — scripts propios (prefijo cd-)

function cdInitReveal() {
  var els = document.querySelectorAll('.cd-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('cd-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('cd-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  els.forEach(function (el) { observer.observe(el); });
}

document.addEventListener('DOMContentLoaded', function () {
  cdInitReveal();
});
